import {_figures} from "../_section/_figures";

export class Figures extends _figures {
    constructor({section}) {
        const app = `applicant${section.applicant + 1}`;
        super({
            section,
            formName: [app, 'monthlyOutgoings', 'loans'],
        });
    }

    get claimedMonthlyPayment() {
        return this.section.data.monthlyPayment || 0
    }

    get monthlyPayment() {
        // get a copy of active uplaods and sort by date desc; then get the first one's monthly payment - if not present add warning and use the next ones with monthly payment
        let monthlyPayment = 0;
        if (!this.section.activeUploads?.length) {
            return {
                warning: `No uploads available - using claimed figure`,
                claimed: this.claimedMonthlyPayment,
                description: this.section.title,
                amount: this.claimedMonthlyPayment,
                uploadID: null,
            }
        }
        const uploadsWithDate = this.section.activeUploads
            .filter(u => u.values.endDate)
            .sort((a, b) => b.values.endDate - a.values.endDate);

        // most recent
        monthlyPayment = uploadsWithDate[0]?.values?.monthlyPayment;
        if (monthlyPayment) {
            return {
                claimed: this.claimedMonthlyPayment,
                description: this.section.title,
                amount: monthlyPayment,
                uploadID: uploadsWithDate[0].id,
            }
        }
        const monthlyPaymentUpload = uploadsWithDate.find(u => u.values.monthlyPayment);
        monthlyPayment = monthlyPaymentUpload?.values.monthlyPayment || 0;
        if (monthlyPayment) {
            return {
                warnings: `Most recent upload is missing monthly payment value`,
                claimed: this.claimedMonthlyPayment,
                description: this.section.title,
                amount: monthlyPayment,
                uploadID: monthlyPaymentUpload.id,
            }
        }
        return {
            warning: `No verified value - using claimed figure`,
            claimed: this.claimedMonthlyPayment,
            description: this.section.title,
            amount: this.claimedMonthlyPayment,
            uploadID: null,
        }

    }


}